module.exports = __webpack_public_path__ + "img/logo-landscape.6d711abc.jpg";